import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.a0k4/v',
    defaultMessage: 'Connected apps',
  },
});
